import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtrarAlmArticulos'
})
export class FiltrarAlmArticulosPipe implements PipeTransform {

  transform(value: any[], searchText: string, opcion?:string): any[] {

    if (!value) return [];
    if (!searchText) return value;

    searchText = searchText.toLowerCase();

    if(opcion && opcion=='1'){
      let algo=value.filter((item: any) => {
        let prov =item.strProveedor.toLowerCase();
        return prov==searchText ;
     });
     return algo
    }
    else {
      return value.filter((item: any) => {
          return item.strArticulo.toLowerCase().includes(searchText);
      });
    }
  }
}
